import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export const Footer: React.FC = () => {
  const { t } = useLanguage();

  return (
    <footer className="mt-auto border-t border-white/[0.05] py-6 sm:py-8 text-center bg-black/20 backdrop-blur-sm" style={{ marginBottom: '80px' }}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 space-y-2 sm:space-y-3">
        <p className="text-xs text-slate-500">
          {t.weatherDataFrom}{' '}
          <a className="text-slate-400 hover:text-white transition-colors" href="https://open-meteo.com/" target="_blank" rel="noopener noreferrer">
            Open-Meteo
          </a>
          {' '}• {t.mapsFrom}{' '}
          <a className="text-slate-400 hover:text-white transition-colors" href="https://www.openstreetmap.org/" target="_blank" rel="noopener noreferrer">
            OpenStreetMap
          </a>
          {' '}• {t.builtBy}{' '}
          <a className="text-slate-400 hover:text-white transition-colors" href="https://skitfiske.app" target="_blank" rel="noopener noreferrer">
            Skitfiske.app
          </a>
        </p>
        <p className="text-xs text-slate-500">
          {t.newHere}{' '}
          <span
            onClick={() => {
              localStorage.removeItem('weatherAppOnboarding');
              window.location.reload();
            }}
            className="text-slate-400 hover:text-white transition-colors cursor-pointer underline"
          >
            {t.showGuide}
          </span>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
